import type { FaireProductEntity } from "../../entity_types/product";

export const p_54cnw4d36p: FaireProductEntity = {
  token: "p_54cnw4d36p",
  type: "product",
  name: "Zoe Lace Trim Satin Dress",
  brandToken: "b_2mvdyzg3tq",
  brandName: "Olivaceous",
  imageUrl:
    "https://cdn.faire.com/fastly/41d2e377ca6612740fc6827dfe67d9e6508cfaeb19ca954e169d5150bb35cefb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9cdd7f9e9f46cbc84783d3504bca56b17b4bd4d9e81c992e05703de309219885.jpeg",
    "https://cdn.faire.com/fastly/d48d84df16e8e1c8dace9c07a53d7c1c509d8a2169d7224b9e00d23690bf0e46.jpeg",
    "https://cdn.faire.com/fastly/567e5b09f41f464b2f3d429df84ab473700545d0434f54101aea7e4c9fecb2e3.jpeg",
    "https://cdn.faire.com/fastly/d7242bdc88d41fc95a56bf83080c5ee5c9405588bdce80af2fceadfbf1901ec2.jpeg",
    "https://cdn.faire.com/fastly/7b719ff49a2880a25d942e1559045c975daa6bab2ba87b2d9925721d89073650.jpeg",
    "https://cdn.faire.com/fastly/82f92df23bf5db5c860f4c0ffdcefc8163fcecfd25e0a33a4e6d19dadab3103a.jpeg",
    "https://cdn.faire.com/fastly/0662744d52887e1c552a3a0a7af387f91f4aa6423d0fb4bef8a238049cbac469.jpeg",
    "https://cdn.faire.com/fastly/35ef2fc92785bad6e5ff7f9aa9a28945500be838e0bdc07fd827a7c4bc57bab2.jpeg",
  ],
  priceDollars: 208.13,
  description:
    "Our Zoe Lace Trim Satin Dress features a lustrous satin finish and delicate lace trim for an effortlessly elegant look. Designed with a mock neckline, sleeveless silhouette, back keyhole tie closure, and ankle above length hem, it's perfect for cocktail parties, weddings, date nights, and special occasions.\n\nWoven",
  tags: [],
  msrpDollars: 416.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:52.008Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
